import Vue from 'vue'
import store from '../store/store'

const _showError = (error) => {
  console.log('error : ', error)
  let defaultMsg = 'Beklenmeyen bir hata oluştu, lütfen daha sonra yeniden deneyiniz.'

  try {
    if (error.response.status == 401) {
        defaultMsg = 'Oturumunuz sonlanmıştır, lütfen tekrar giriş yapınız.'
      store.dispatch('logout')
    }else if(error.response.data){
      let msg = error.response.data
      defaultMsg = msg.Message
    }
  } catch (err) { }

  
  store.state.alertObject = {
    message: defaultMsg,
    color: 'error',
    y: 'top'
  }

}

const _showSuccess = (msg, position = 'top') => {
  store.state.alertObject = { message: msg, color: 'success', y: position }
}

const _showInfo = (msg, type = 'standart', color = 'info') => {
  switch (type) {
    case 'standart':
      store.state.alertObject = { message: msg, color, y: 'top' }
    case 'notification':
      store.state.alertObject = { message: msg, color, y: 'bottom', x: 'right' }
  }
}

const _showWarning = (msg) => {
  store.state.alertObject = { message: msg, color: 'warning', y: 'top' }
}

const _toggleLoading = (val = null) => {
  if (!val) store.state.actionLoading = !store.state.actionLoading
  else store.state.actionLoading = val
}

const _showNewContent = (msg) => {
  store.state.newContentButtonObject = { message: msg, color: 'info', y: 'top' }
}

window.showError = Vue.prototype.showError = _showError
window.showSuccess = Vue.prototype.showSuccess = _showSuccess
window.showInfo = Vue.prototype.showInfo = _showInfo
window.showWarning = Vue.prototype.showWarning = _showWarning
window.showNewContent = Vue.prototype.showNewContent = _showNewContent
window.toggleLoading = Vue.prototype.toggleLoading = _toggleLoading
